import debug from './debug';
import { hashString } from './hashString';
/**
 * Embed Script tag into document
 * Only loads once
 *
 * @return Promise
 */
export const loadScriptTag = (url, doc = document) => new Promise(resolve => {
    const id = hashString(url);
    const existingElement = doc.getElementById(id);
    // Avoid double loading the same script
    if (existingElement) {
        resolve(url);
        return;
    }
    const element = doc.createElement('script');
    element.id = id;
    element.async = true;
    element.src = url;
    element.onload = () => resolve(url);
    element.onerror = () => {
        debug('Cannot load script URL:', url);
        resolve(url);
    };
    doc.body.appendChild(element);
});
